import { helloSupervisor } from '../../../../../img/images';
import { ILocalization } from '../../../../../localization/definitions/types';

interface Props {
    localization: ILocalization;
}

export const HelloSupervisorSlideImage = () => {
    return (
        <div className='carousel-img w-100 h-100'>
            <div className='hello-supervisor-slide'></div>
        </div>
    );
};

export const HelloSupervisorSlideImageSrc = helloSupervisor;

export const HelloSupervisorSlideContent = ({ localization }: Props) => {
    const { helloSupervisorSlide } =
        localization.localizationStrings.susy.thesisManagement.tutorial
            .supervisor.slides;

    return (
        <div
            data-testid='first-slide'
            className='tutorial-content-wrapper hello-supervisor-slide-content'
        >
            <h1>{helloSupervisorSlide.helloMyName} ​</h1>
            <h4>{helloSupervisorSlide.imYourNewSystem}</h4>
            <div className='instruction-row'>
                <div className='instruction-content'>
                    {helloSupervisorSlide.myJobIs}
                </div>
            </div>
        </div>
    );
};
